import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { SidebarProps } from '../../../shared/prop-types/ReducerProps';
import reportData from './../../Dashboards/Default/dynamic';
import staticData from './../../Dashboards/Default/static';
import axios from 'axios';

class ToggleCollapsedMenu extends PureComponent {

  state = {
	  items : this.props.items,
	  static_items : this.props.static_items,
	  collapse : this.props.report_obj.show
  }

  getAllTiles = (tile_type,tile_data) => {
	var url = window.location.hostname;
	var port = window.location.port;

	if (url === "localhost") {
         url= "15.206.34.41"+":8090";
        }else{
         url= window.location.hostname+":8088";
        }
	
	if(url.indexOf("localhost" <= -1)){ 
	axios('http://'+url+'/reports/json_func/v1/',
	{
	  method: 'POST',
	  headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'Authorization' : this.accessCookie("token")
	  },
	  data:{
		"tile_type":tile_type,
		"tile_data": tile_data,
	  }
	}).then((response) => {
	}).then((response) => {
		if(tile_type == "dynamic"){
			this.props.dynamic_tile_toggle();
		}else{
			this.props.static_tile_toggle();
		}
  })
	}
}
  toggle = (result) => { 
	if(result.category == "static"){
		console.log(this.props.static_items);
		console.log("STATIC",this.state.static_items);
		this.setState({collapse : !this.state.collapse});
		this.state.static_items.map((obj,index) => {
			if(obj.id === result.id){
				obj.show = !result.show;
			}else{
				if(this.props.static_items[index].show != obj.show){
						obj.show = !obj.show;
				}
			}
		})
		this.setState({static_items : this.state.static_items});
		
		this.getAllTiles("static",JSON.stringify(this.state.static_items));
	}else{
		this.setState({collapse : !this.state.collapse});
		this.state.items.map((obj,index) => {
			if(obj.id == result.id){
				obj.show = !result.show;
			}
		})
		this.setState({items : this.state.items});
		this.getAllTiles("dynamic",JSON.stringify(this.state.items));
	}
  }
  
  
  accessCookie = (cookieName) =>{
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++)
          {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
         }
        return "";
        }

  render() {
    return (
      <label className="toggle-btn customizer__toggle" htmlFor="collapse_toggle" onClick = {() => this.toggle(this.props.report_obj)} >
        <input
          className="toggle-btn__input"
          type="checkbox"
          name="collapse_toggle"
          id={this.props.report_obj.id}
          checked={this.props.report_obj.show}
		  onChange = {this.toggle}
        />
        <span className="toggle-btn__input-label" />
        <span>{this.props.report_obj.display_text}</span>
      </label>
    );
  }
}

export default ToggleCollapsedMenu;
